import React from 'react';
import { Paper, Stack, Box, Typography, Divider } from '@mui/material';
import { Schedule, Person, Phone } from '@mui/icons-material';

interface CallInfoSectionProps {
  formattedDate: string;
  formattedTime: string;
  callBy: string;
  callTo: string;
}

export const CallInfoSection: React.FC<CallInfoSectionProps> = ({
  formattedDate,
  formattedTime,
  callBy,
  callTo
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 1.5
      }}
    >
      <Stack spacing={2.5}>
        {/* Date and Time */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Schedule sx={{ color: '#3b82f6', fontSize: 20 }} />
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b' }}>
              Call Date & Time
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
              {formattedDate} at {formattedTime}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#e2e8f0' }} />

        {/* Caller */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Person sx={{ color: '#3b82f6', fontSize: 20 }} />
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b' }}>
              Call Made By
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
              {callBy}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#e2e8f0' }} />

        {/* Call To */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Phone sx={{ color: '#3b82f6', fontSize: 20 }} />
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b' }}>
              Called To
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
              {callTo}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};
